module.exports = __webpack_public_path__ + "dist/media/hiram-aragon.783bbf10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/team/hiram-aragon.png
// module id = 386
// module chunks = 0